module.exports = __webpack_public_path__ + "img/gyd.eed1cbe6.svg";